/* eslint-disable react/no-array-index-key */
/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Menu,
  Dropdown,
  Checkbox,
  Button,
  Table,
  Form,
  Select,
  Spin,
  Modal,
  Skeleton,
  message,
} from "antd";
import { DownOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
import Layout from "../../../layouts/MocoLayout";
import { NavigationMenuCard } from "../../../components/ui";
import { MocoCard } from "../../../components/widget";
import oRest from "../../../apis/rest";
import config from "./index.config";
import "./index.scss";

const API_URL = "webhook/dataquery/?qname=";

const Page = () => {
  const [allData, setAllData] = useState(null);
  const [dataSource, setDataSource] = useState(null);
  const [provinsiList, setProvinsiList] = useState([]);
  const [provinceMenu, setProvinceMenu] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [focusModal, setFocusModal] = useState(null);
  const [cards, setCards] = useState(config.cards);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const { data } = await oRest.get(
          `${API_URL}kemenag_pesantren_jenis_usaha_summary`
        );

        setAllData(data);
        setDataSource(data.map((e, idx) => ({ ...e, id: idx })));

        setCards((card) => ({
          ...card,
          table: {
            ...card.table,
            jenisUsaha: {
              ...card.table.jenisUsaha,
              options: {
                ...card.table.jenisUsaha.options,
                dataSource: data.map((e, idx) => ({ ...e, id: idx })),
              },
            },
          },
        }));
      } catch (error) {
        console.log(error);
        message.error("Terjadi kesalahan");
      }
    };
    fetchAllData();
  }, []);

  useEffect(() => {
    const fetchProvinsi = async () => {
      try {
        const { data } = await oRest.get(`${API_URL}kemenag_all_provinsi`);
        setProvinsiList(data.map((e) => e.provinsi));
      } catch (error) {
        message.error("Terjadi kesalahan");
        console.log(error);
      }
    };
    fetchProvinsi();
  }, []);

  useEffect(() => {
    const fetchDetailData = async () => {
      try {
        if (typeof focusModal === "object" && focusModal) {
          const { data } = await oRest.get(
            `${API_URL}kemenag_pesantren_jenis_usaha_detail_v2&keyword={${focusModal?.join(
              ","
            )}}&provinsi=${provinceMenu ?? ""}`
          );
          setModalData(data);
          setBtnLoading(false);
        } else if (typeof focusModal === "string") {
          const { data } = await oRest.get(
            `${API_URL}kemenag_pesantren_jenis_usaha_detail&keyword=${focusModal}&provinsi=${
              provinceMenu ?? ""
            }`
          );
          setModalData(data);
          setBtnLoading(false);
        }
      } catch (error) {
        console.log(error);
        message.error("Terjadi kesalahan");
      }
    };

    fetchDetailData();
  }, [focusModal]);

  const jenisUsahaDropdownMenu = (
    <Menu>
      <Row>
        <Form.Item name="jenisUsaha">
          <Checkbox.Group>
            <Row
              justify="space-around"
              gutter={[8, 8]}
              style={{
                margin: "0px 12px 0px 12px",
                width: 400,
              }}
            >
              {allData?.map((e, idx) => {
                return (
                  <Col key={idx} span={12}>
                    <Checkbox value={e.jenis_usaha}>{e.jenis_usaha}</Checkbox>
                  </Col>
                );
              })}
            </Row>
          </Checkbox.Group>
        </Form.Item>
      </Row>
    </Menu>
  );

  const mainTableColumn = [
    {
      title: "Jenis Usaha",
      dataIndex: "jenis_usaha",
      key: "jenis_usaha",
      render: (item) => {
        if (typeof item === "object" && item !== null) {
          return item.join(", ");
        }
        return item;
      },
      sorter: (a, b) => a.jenis_usaha.localeCompare(b.jenis_usaha),
    },
    {
      title: "Jumlah",
      key: "total",
      sorter: (a, b) => a.total - b.total,
      render: (item) => {
        return (
          <Button
            type="text"
            key={item.jenis_usaha}
            onClick={() => {
              setBtnLoading(true);
              setFocusModal(item.jenis_usaha);
              setModalVisible(true);
            }}
            style={{
              textAlign: "left",
            }}
            block
          >
            {item.total}
          </Button>
        );
      },
    },
  ];

  const detailTableColumn = [
    {
      title: "Pondok Pesantren",
      dataIndex: "pesantren",
    },
    {
      title: "Kabupaten",
      dataIndex: "kab_kota",
    },
    {
      title: "Alamat",
      dataIndex: "alamat",
    },
  ];

  const handleFinishFilter = async (values) => {
    setDataSource(null);
    try {
      const { provinsi, jenisUsaha } = values;

      if (provinsi === "nasional") setProvinceMenu(null);

      if (provinsi !== "nasional" && provinsi !== undefined)
        setProvinceMenu(provinsi);

      const tempProvince =
        provinsi === undefined || provinsi === "nasional" ? "" : provinsi;

      const titleCard = `Detail Usaha ${
        jenisUsaha.length === 0 ? "Ekonomi" : `${jenisUsaha}`
      } di ${
        provinsi === "nasional" || provinsi === "undefined"
          ? "Seluruh Provinsi"
          : `Provinsi ${provinsi}`
      }`;

      if (jenisUsaha.length !== 0) {
        const { data } = await oRest.get(
          `${API_URL}kemenag_jenis_usaha_filter&keyword={${jenisUsaha.join(
            ","
          )}}&provinsi=${tempProvince}`
        );

        setDataSource(data.map((e, idx) => ({ ...e, id: idx })));
        setCards((card) => ({
          ...card,
          table: {
            ...card.table,
            jenisUsaha: {
              ...card.table.jenisUsaha,
              content: {
                ...card.table.jenisUsaha.content,
                title: titleCard,
              },
              options: {
                ...card.table.jenisUsaha.options,
                dataSource: data.map((e, idx) => ({ ...e, id: idx })),
              },
            },
          },
        }));
      } else {
        const { data } = await oRest.get(
          `${API_URL}kemenag_jenis_usaha_filter_provinsi&keyword=${tempProvince}`
        );

        setDataSource(data.map((e, idx) => ({ ...e, id: idx })));
        setCards((card) => ({
          ...card,
          table: {
            ...card.table,
            jenisUsaha: {
              ...card.table.jenisUsaha,
              content: {
                ...card.table.jenisUsaha.content,
                title: titleCard,
              },
              options: {
                ...card.table.jenisUsaha.options,
                dataSource: data.map((e, idx) => ({ ...e, id: idx })),
              },
            },
          },
        }));
      }
    } catch (error) {
      console.log(error);
      message.error("Terjadi kesalahan");
    }
  };

  return (
    <section id="penyajian-pencarian">
      <Layout>
        <NavigationMenuCard
          menu={[
            { title: "Sebaran", path: "/pondok-pesantren" },
            { title: "Pendidikan", path: "/pondok-pesantren/pendidikan" },
            { title: "Dakwah", path: "/pondok-pesantren/dakwah" },
            {
              title: "Pemberdayaan Masyarakat",
              path: "/pondok-pesantren/pemberdayaan-masyarakat",
            },
            {
              title: "Penyajian dan Pencarian",
              path: "/pondok-pesantren/penyajian-pencarian",
            },
          ]}
        />
        <Row
          style={{
            margin: "24px 0",
          }}
        >
          <Col span={24}>
            <Form onFinish={handleFinishFilter}>
              <Row justify="end" align="top" gutter={[32, 24]}>
                <Dropdown
                  trigger={["click"]}
                  overlay={jenisUsahaDropdownMenu}
                  overlayStyle={{
                    height: 400,
                    overflow: "auto",
                  }}
                >
                  <Button
                    size="large"
                    shape="round"
                    style={{
                      backgroundColor: "#1B6FBA",
                      color: "#fff",
                    }}
                  >
                    Pilih jenis usaha &nbsp;
                    <DownOutlined />
                  </Button>
                </Dropdown>
                <Form.Item name="provinsi">
                  <Select
                    placeholder="Pilih provinsi"
                    size="large"
                    style={{ width: 200 }}
                  >
                    <Select.Option value="nasional">Nasional</Select.Option>
                    {provinsiList?.map((e) => {
                      return (
                        <Select.Option key={e} value={e}>
                          {e}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Button
                  htmlType="submit"
                  size="large"
                  shape="round"
                  style={{
                    backgroundColor: "#1B6FBA",
                    color: "#fff",
                  }}
                >
                  Cari
                </Button>
              </Row>
            </Form>
          </Col>
          <Col span={24}>
            <Skeleton loading={!dataSource} className="skeleton">
              <MocoCard
                {...cards.table.jenisUsaha.content}
                options={cards.table.jenisUsaha.options}
              >
                <Table
                  columns={mainTableColumn}
                  dataSource={dataSource ?? []}
                  rowKey={(row) => row.id}
                  rowClassName={(record, index) => {
                    return index % 2 === 0
                      ? "table-row-lighter"
                      : "table-row-darker";
                  }}
                />
                <Modal
                  title="Detail Jenis Usaha"
                  width={768}
                  visible={modalVisible}
                  onOk={() => {
                    setModalVisible(false);
                  }}
                  onCancel={() => {
                    setModalVisible(false);
                  }}
                >
                  {btnLoading ? (
                    <Spin size="large" />
                  ) : (
                    <div>
                      <Row justify="end">
                        <Button
                          size="large"
                          shape="round"
                          style={{
                            backgroundColor: "#1B6FBA",
                            color: "#fff",
                          }}
                        >
                          <CSVLink
                            data={modalData ?? []}
                            headers={detailTableColumn.map((e) => {
                              return {
                                label: e.title,
                                key: e.dataIndex,
                              };
                            })}
                            filename="Detail Data Pesantren.csv"
                            separator=";"
                          >
                            Ekspor ke CSV
                          </CSVLink>
                        </Button>
                      </Row>
                      <Table
                        columns={detailTableColumn}
                        dataSource={modalData?.map((e, idx) => ({
                          ...e,
                          id: idx,
                        }))}
                        rowKey={(row) => row.id}
                        rowClassName={(record, index) => {
                          return index % 2 === 0
                            ? "table-row-lighter"
                            : "table-row-darker";
                        }}
                      />
                    </div>
                  )}
                </Modal>
              </MocoCard>
            </Skeleton>
          </Col>
        </Row>
      </Layout>
    </section>
  );
};

export default Page;
